/* eslint-disable react/require-default-props */
import {
  Box, Checkbox, FormControlLabel, Grid2, MenuItem, Slider, Typography,
} from '@mui/material';
import { FUEL_TYPE, TRANSMISSION_TYPE } from '@plugins/vehiclefleetapp';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import orderBy from 'lodash/orderBy';
import Select from '@components/atoms/Select';
import { transformBrandTitle } from '../CarBrandTitle';

export default function BasicFiltersGroup(props) {
  const {
    t,
    data,
    handlers,
  } = props;

  return (
    <Grid2 container spacing={3}>
      <Grid2 size={{
        md: 4,
        xs: 12,
      }}
      >
        <FormSelect
          id="vehicle-category-select"
          items={data.categories.map((value) => ({
            label: t(`enums.vehicleCategory.${value || 'unknown'}`),
            value,
          }))}
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.vehicleType')}
          onChange={handlers.onChangeCategory}
          value={data.category}
        />
      </Grid2>
      <Grid2 size={{
        md: 4,
        xs: 12,
      }}
      >
        <FormSelect
          id="brand-select"
          items={[
            {
              label: t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.allBrands'),
              value: null,
            },
            ...data.brands.map((value) => ({
              label: transformBrandTitle(value),
              value,
            })),
          ]}
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.brand')}
          onChange={handlers.onChangeBrand}
          value={data.brand}
        />
      </Grid2>
      <Grid2 size={{
        md: 4,
        xs: 12,
      }}
      >
        <FormSelect
          id="brand-select"
          items={[
            {
              label: t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.allModels'),
              value: null,
            },
            ...data.models.map((value) => ({
              label: value,
              value,
            })),
          ]}
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.model')}
          onChange={handlers.onChangeModel}
          value={data.model}
        />
      </Grid2>
      <Grid2 size={{
        md: 4,
        xs: 12,
      }}
      >
        <FormSelect
          id="fuel-type-select"
          items={[
            {
              label: t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.allFuels'),
              value: null,
            },
            ...orderBy(data.fuelTypes.map((value) => ({
              label: FUEL_TYPE[value],
              value,
            })), ['label']),
          ]}
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.fuel')}
          onChange={handlers.onChangeFuelType}
          value={data.fuelType}
        />
      </Grid2>
      <Grid2 size={{
        md: 4,
        xs: 12,
      }}
      >
        <FormSelect
          id="transmission-select"
          items={[
            {
              label: t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.allTransmissions'),
              value: null,
            },
            ...orderBy(data.transmissions.map((value) => ({
              label: TRANSMISSION_TYPE[value],
              value,
            })), ['label']),
          ]}
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.transmission')}
          onChange={handlers.onChangeTransmission}
          value={data.transmission}
        />
      </Grid2>
      <Grid2 size={{
        md: 4,
        xs: 12,
      }}
      >
        <FormSelect
          id="branch-select"
          items={[
            {
              label: t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.allLocations'),
              value: null,
            },
            ...orderBy(data.branches.map((value) => ({
              label: value.attributes.name,
              value: value.id,
            })), ['label']),
          ]}
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.location')}
          onChange={handlers.onChangeBranch}
          value={data.branch}
        />
      </Grid2>
      <Grid2 size={{
        md: 6,
        xs: 12,
      }}
      >
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography component="div" variant="button">
              {t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.availabilityActions')}
            </Typography>
          </Grid2>
          <Grid2 size={{
            md: 6,
            xs: 12,
          }}
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={data.availableNow ?? false}
                  color="primary"
                  onChange={handlers.onChangeAvailableNow}
                />
              )}
              label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.availableImmediately')}
            />
          </Grid2>
          <Grid2 size={{
            md: 6,
            xs: 12,
          }}
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={data.saleOnly ?? false}
                  color="primary"
                  onChange={handlers.onChangeSaleOnly}
                />
              )}
              label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.vehiclesOnSale')}
            />
          </Grid2>
          <Grid2 size={12}>
            <Typography component="div" variant="button">
              {t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.typeOfVehicle')}
            </Typography>
          </Grid2>
          <Grid2 size={{
            md: 6,
            xs: 12,
          }}
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={data.newCar ?? false}
                  color="primary"
                  onChange={handlers.onChangeNewCar}
                />
              )}
              label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.newCar')}
            />
          </Grid2>
          <Grid2 size={{
            md: 6,
            xs: 12,
          }}
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={data.usedCar ?? false}
                  color="primary"
                  onChange={handlers.onChangeUsedCar}
                />
              )}
              label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.usedCars')}
            />
          </Grid2>
          <Grid2 size={{
            md: 6,
            xs: 12,
          }}
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={data.isDailyAdmission ?? false}
                  color="primary"
                  onChange={handlers.onChangeIsDailyAdmission}
                />
              )}
              label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.dailyAdmissionCar')}
            />
          </Grid2>
          <Grid2 size={{
            md: 6,
            xs: 12,
          }}
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={data.seductionCar ?? false}
                  color="primary"
                  onChange={handlers.onChangeSeductionCar}
                />
              )}
              label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.demonstrationCar')}
            />
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 size={{
        md: 6,
        xs: 12,
      }}
      >
        <FormSlider
          gutterBottom
          id="horsePower"
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.performance')}
          max={data.powerRange[1] ?? 1}
          min={data.powerRange[0] ?? 0}
          onChange={debounce(handlers.onChangeHorsePower, 1000)}
          unit="PS"
          value={data.horsePower ?? data.powerRange ?? [0, 0]}
        />
        <FormSlider
          gutterBottom
          id="initialRegistrationYear"
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.initialRegistration')}
          max={data.initialRegistrationYearRange[1] ?? 1}
          min={data.initialRegistrationYearRange[0] ?? 0}
          onChange={debounce(handlers.onChangeInitialRegistrationYear, 1000)}
          value={data.initialRegistrationYear ?? data.initialRegistrationYearRange ?? [0, 0]}
        />
        <FormSlider
          gutterBottom
          id="mileage"
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.kilometers')}
          max={data.mileageRange[1] ?? 1}
          min={data.mileageRange[0] ?? 0}
          onChange={debounce(handlers.onChangeMileage, 1000)}
          unit="km"
          value={data.mileage ?? data.mileageRange ?? [0, 0]}
        />
        <FormSlider
          gutterBottom
          id="price"
          label={t('components.vehiclefleet.SearchAndFilterBar.BasicFiltersGroup.price')}
          max={data.priceRange[1] ?? 1}
          min={data.priceRange[0] ?? 0}
          onChange={debounce(handlers.onChangePrice, 1000)}
          unit="€"
          value={data.price ?? data.priceRange ?? [0, 0]}
        />
      </Grid2>
    </Grid2>
  );
}

BasicFiltersGroup.propTypes = {
  data: PropTypes.object.isRequired,
  handlers: PropTypes.object.isRequired,
};

function FormSelect(props) {
  const {
    id,
    label,
    value,
    items,
    onChange,
  } = props;

  return (
    <Select
      label={label}
      onChange={onChange}
      value={value ?? ''}
    >
      {items.map(({
        label: label2,
        value: value2,
      }) => (
        <MenuItem key={value2} value={value2}>
          {label2}
        </MenuItem>
      ))}
    </Select>
  );
}

FormSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
  })),
  // Events
  onChange: PropTypes.func,
};

export function FormSlider(props) {
  const {
    id,
    label,
    value,
    min,
    max,
    step,
    unit,
    gutterBottom,
    scaleMinValue,
    scaleMaxValue,
    onChange,
    sx,
  } = props;
  const [sliderValue, setSliderValue] = useState(value);

  useEffect(() => {
    setSliderValue(value);
  }, [value]);

  const handleChange = (e, value2) => {
    setSliderValue(value2);
    onChange(e, value2);
  };

  let leftValue = Array.isArray(sliderValue) ? sliderValue[0] : sliderValue;
  let rightValue = Array.isArray(sliderValue) ? sliderValue[1] : 0;

  if (scaleMinValue) {
    leftValue = scaleMinValue(leftValue);
  }

  if (scaleMaxValue) {
    rightValue = scaleMaxValue(rightValue);
  }

  return (
    <Box
      id={id}
      mb={gutterBottom ? 2 : 0}
      sx={sx}
    >
      <Typography
        id="continuous-slider"
        variant="button"
      >
        {label}
      </Typography>
      <Grid2
        alignItems="center"
        container
      >
        <Grid2 size={{ xs: 2 }} sx={{ width: 70 }}>
          <Typography
            sx={{
              whiteSpace: 'nowrap',
            }}
            variant="body2"
          >
            {`${leftValue ?? '-'} ${unit ?? ''}`.trim()}
          </Typography>
        </Grid2>
        <Grid2
          size={{ xs: 8 }}
          sx={{
            flex: 1,
            mx: 2,
          }}
        >
          <Box mb={-0.65}>
            <Slider
              aria-label={label}
              component="div"
              max={max}
              min={min}
              onChange={handleChange}
              size="small"
              step={step ?? 1}
              value={[...sliderValue]}
              valueLabelDisplay="auto"
            />
          </Box>
        </Grid2>
        {Array.isArray(sliderValue) && (
          <Grid2 size={{ xs: 2 }} sx={{ width: 70 }}>
            <Typography
              align="right"
              sx={{
                whiteSpace: 'nowrap',
              }}
              variant="body2"
            >
              {`${rightValue ?? '-'} ${unit ?? ''}`.trim()}
            </Typography>
          </Grid2>
        )}
      </Grid2>
    </Box>
  );
}

FormSlider.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  unit: PropTypes.string,
  gutterBottom: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
  })),
  scaleMinValue: PropTypes.func,
  scaleMaxValue: PropTypes.func,
  // Events
  onChange: PropTypes.func,
};
